import Icon from "~/components/ui/Icon"
import type { JSX } from "react"
import { Group, useFAQ } from "~/components/institutional/FAQ/useFAQ"

function sanitizeText(text: string) {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .toLowerCase()
}

export default function Search({ groups }: { groups: Group[] }) {
    const { setSearch } = useFAQ()

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        const form = event.currentTarget
        const formData = new FormData(form)
        const query = formData.get('query')?.toString()

        if (!query) return

        const questions = groups.flatMap(({ questions }) => questions)

        const filtered = questions.filter(({ question, answer }) => {
            const sanitizedQuestion = sanitizeText(question)
            const sanitizedAnswer = sanitizeText(answer)
            const sanitizedQuery = sanitizeText(query)

            return sanitizedQuestion.includes(sanitizedQuery) ||
                sanitizedAnswer.includes(sanitizedQuery)
        })

        setSearch(query, filtered)
    }

    return (
        <form
            className='w-full max-w-lg h-12 border border-[#e8e8e8] rounded-[5px] overflow-hidden bg-white flex'
            onSubmit={onSubmit}
        >
            <input
                className='w-full h-full px-4 outline-none text-sm placeholder:text-[#757575]'
                name='query'
                type='text'
                placeholder='Procure por termos específicos'
            />

            <button className='px-4 text-salmon'>
                <Icon id='MagnifyingGlass' size={24} />
            </button>
        </form>
    )
}
